import React, { useState } from 'react';
import { Text } from '@uhg-abyss/web/ui/Text';
import { Link } from '@uhg-abyss/web/ui/Link';
import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { SuggestProgramModal } from './SuggestProgramModal';
import { SuggestProgramType } from '@src/api.types';

export const Footer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSuggestOpen, setIsSuggestOpen] = useState(false);

  const emptySuggestProgram: SuggestProgramType = {
    providerCBOName: '',
    programName: '',
    programPhone: '',
    programWebsite: '',
    stateCode: '',
    notes: '',
  };

  return (
    <React.Fragment>
      <div
        data-cy="footer"
        style={{
          backgroundColor: '#002677',
          paddingTop: '10px',
          paddingBottom: '10px',
          paddingLeft: '10px',
          paddingRight: '10px',
          display: 'flex',
          justifyContent: 'space-between',
        }}
        className="noPrint"
      >
        {' '}
        <Text color="white">© 2026 UnitedHealthcare</Text>
        <div style={{ justifyContent: 'end' }}>
          <Text
            onClick={() => setIsOpen(true)}
            style={{ paddingLeft: '8px', color: 'white', cursor: 'pointer' }}
          >
            Need Support?
          </Text>
          <Text
            onClick={() => setIsSuggestOpen(true)}
            style={{ paddingLeft: '8px', color: 'white', cursor: 'pointer' }}
          >
            | Suggest a Program
          </Text>
        </div>
      </div>

      <ModalDialog
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        css={{
          'abyss-modal-content-container': {
            height: '100%',
          },
          'abyss-modal-body': {
            maxHeight: '-webkit-fill-available',
          },
          'abyss-modal-close-button': {
            right: '27px',
          },
        }}
      >
        <div>
          <Heading size="sm" style={{ paddingTop: '14px' }}>
            Before contacting the UHC Community Connector team or IT Help Desk,
            first step is to check your access in Secure
          </Heading>
        </div>
        <div>
          <Text>
            {' '}
            Go to{' '}
            <Link href="https://secure.uhc.com/">
              UnitedHealth Group - Secure (uhc.com)
            </Link>{' '}
            and then select "My Access" and then "Current Access". You must have
            access to both Community Connector and either findhelp or Unite Us.
          </Text>
          <Text>
            {' '}
            Instructions for Secure access and Secure access requirements can be
            found in the {' '}
            <Link href="https://teams.microsoft.com/l/team/19%3An_ggCY4Gkh9zbip-yJKpIAFyGUnbBoA-8Kr38ys42po1%40thread.tacv2/conversations?groupId=abfac4dd-2dba-4d9e-a4d5-0a711074eee8&tenantId=db05faca-c82a-4b9d-b9c5-0f64b6755421">
              Community Connector Teams channel
            </Link>
            .
          </Text>
        </div>
        <div>
          <Heading size="sm">
            How to Report Issues
          </Heading>
        </div>
        <div>
          <Text>
            Submit issues using the Teams channel for{' '}
            <Link href="https://teams.microsoft.com/l/channel/19%3An_ggCY4Gkh9zbip-yJKpIAFyGUnbBoA-8Kr38ys42po1%40thread.tacv2/General?groupId=abfac4dd-2dba-4d9e-a4d5-0a711074eee8&tenantId=db05faca-c82a-4b9d-b9c5-0f64b6755421">
              Community Connector
            </Link>
            ,<br></br>
            Please be as descriptive as possible. Explanations such as “It’s
            glitching”, “It’s not working” are not helpful and only delay your
            getting the issue resolved.
          </Text>
        </div>
        <div>
          <Heading size="sm">
            Troubleshooting steps if you have an issue
          </Heading>
        </div>
        <div>
          <Text>
            Additional information on Secure access requirements,
            troubleshooting tips can be found in the{' '}
            <Link href="https://teams.microsoft.com/l/team/19%3An_ggCY4Gkh9zbip-yJKpIAFyGUnbBoA-8Kr38ys42po1%40thread.tacv2/conversations?groupId=abfac4dd-2dba-4d9e-a4d5-0a711074eee8&tenantId=db05faca-c82a-4b9d-b9c5-0f64b6755421">
              Community Connector Teams channel
            </Link>
            .{' '}
          </Text>
          <p style={{ fontWeight: 'bold', marginTop: '14px', marginBottom: '4px' }}>
            No resources visible in Community Connector
          </p>
          <Text>
            Unable to see resources is an indication you either do not have Secure access for
            the network resource partner (findhelp or Unite Us) or your access has gone inactive.
            The Secure access instructions also include what access you need based on the market
            and line of business you serve.
          </Text>
          <p style={{ fontWeight: 'bold', marginTop: '14px', marginBottom: '4px' }}>
            If you get this error message when you launch Community Connector:
          </p>
          <Text>
            “403 Forbidden Microsoft-Azure-Application-Gateway/v2” <br></br>
            Clear cache to resolve the issue and instructions are below.
          </Text>{' '}
          <p style={{ fontWeight: 'bold', marginTop: '14px', marginBottom: '4px' }}>Chrome:</p>
          <Text>
            To clear your cache in{' '}
            <Link href="https://www.google.com/search?q=+clear+cache+chrome+&sca_esv=0d1ece0734f8e806&source=hp&ei=_r19Z4PnHb_OkPIP_9CkiAk&iflsig=AL9hbdgAAAAAZ33MDko1ElVUPnXycsIvAQy8jkaROA2Q&ved=0ahUKEwiD3tHi5uSKAxU_J0QIHX8oCZEQ4dUDCBA&uact=5&oq=+clear+cache+chrome+&gs_lp=Egdnd3Mtd2l6IhQgY2xlYXIgY2FjaGUgY2hyb21lIDIFEAAYgAQyBRAAGIAEMgUQABiABDIFEAAYgAQyBRAAGIAEMgUQABiABDIFEAAYgAQyBRAAGIAEMgUQABiABDIFEAAYgARIkz1QAFi9InACeACQAQCYAZsBoAGWAqoBAzAuMrgBA8gBAPgBAvgBAZgCBKACuQLCAgUQIRigAcICBRAhGKsCmAMAkgcDMi4yoAfTCw&sclient=gws-wiz">
              Google Chrome
            </Link>
            .
          </Text>
          <p style={{ fontWeight: 'bold', marginTop: '14px', marginBottom: '4px' }}>Edge:</p>
          <Text>
            To clear the cache in{' '}
            <Link href="https://www.google.com/search?q=clear+cache+edge&sca_esv=0d1ece0734f8e806&ei=CL59Z_H9DqD6kPIPprjvmAE&ved=0ahUKEwjxoaXn5uSKAxUgPUQIHSbcGxMQ4dUDCBA&uact=5&oq=clear+cache+edge&gs_lp=Egxnd3Mtd2l6LXNlcnAiEGNsZWFyIGNhY2hlIGVkZ2UyDhAAGIAEGJECGLEDGIoFMgsQABiABBiRAhiKBTILEAAYgAQYkQIYigUyBRAAGIAEMgUQABiABDIFEAAYgAQyBRAAGIAEMgUQABiABDIFEAAYgAQyBRAAGIAESOQeUKgQWLYWcAJ4AZABAJgBsgGgAcYEqgEDMC40uAEDyAEA-AEBmAIGoAL4BMICChAAGLADGNYEGEfCAg0QABiABBiwAxhDGIoFmAMAiAYBkAYKkgcDMi40oAevFg&sclient=gws-wiz-serp">
              Microsoft Edge
            </Link>
            .  
          </Text>
        </div>
      </ModalDialog>
      <SuggestProgramModal
        programData={emptySuggestProgram}
        isOpen={isSuggestOpen}
        setIsOpen={setIsSuggestOpen}
        isEdit={false}
        onSaveProgram={() => {}}
        listOfValidFields={[]}
        uniteUsRadio=""
      />
    </React.Fragment>
  );
};
